(function() {


  angular.module('PrinterVendorProvider', [])

  .factory('PrinterVendorModel', 
    ['$q', '$http', 'Utils', 
    function($q, $http, Utils) {
      return function(snmpConfigurationData) {
        var PrinterVendorModel = {};
        var PrinterVendorModelPrivate = {};

        PrinterVendorModel.init = function(snmpConfigurationData) {
          if (Utils.objectPropertiesCheck(snmpConfigurationData, ['_links'])) {
            PrinterVendorModel.info = angular.copy(snmpConfigurationData);
            PrinterVendorModel.options = {
              isSelected: false
            };
            PrinterVendorModel.info.name = snmpConfigurationData._embedded.vendor.name;
            PrinterVendorModel.customProperties = {};
            PrinterVendorModelPrivate.normalizeLinks();
          } else {
            throw "PrinterVendorModel: snmpConfigurationData is not valid";
          }
        }

        PrinterVendorModelPrivate.normalizeLinks = function() {
          angular.forEach(PrinterVendorModel.info._links, function(link, index) {
            if (angular.isObject(link) && !angular.isArray(link)) {
              var linkClean = link.href.split("?")[0];
              PrinterVendorModel.info._links[index].href = linkClean;
            }
          });
          var selfHrefSplit = PrinterVendorModel.info._links.self.href.split("/");
          PrinterVendorModel.customProperties.id = selfHrefSplit[selfHrefSplit.length - 1];
        };

      PrinterVendorModel.init(snmpConfigurationData);
      delete PrinterVendorModel.init;
      return PrinterVendorModel;
    }
  }])

  .factory('PrinterVendorListPaging', ['$rootScope', function($rootScope) {
    return function() {
      var PrinterVendorListPaging = {}
      PrinterVendorListPaging.pagingCriteria = {
        page: 0,
        pageSize: 100,
        direction: 'ASC',
        sort: 'NAME',
        printixVerified: true,
        match: null,
      }
      PrinterVendorListPaging.getPagedUrlParameters = function() {
        var urlParameters =
          'page=' + PrinterVendorListPaging.pagingCriteria.page +
          "&pageSize=" + PrinterVendorListPaging.pagingCriteria.pageSize +
          "&direction=" + PrinterVendorListPaging.pagingCriteria.direction +
          "&sort=" + PrinterVendorListPaging.pagingCriteria.sort;
          //  +
          // "&printixVerified=" + PrinterVendorListPaging.pagingCriteria.printixVerified;

        if (PrinterVendorListPaging.pagingCriteria.match) {
          urlParameters += "&match=" + PrinterVendorListPaging.pagingCriteria.match;
        }
        return urlParameters;
      }
      return PrinterVendorListPaging
    }
  }])

  .service('PrinterVendorService',
    ['$q', '$http', 'TenantListService', 'PrinterVendorModel', 
    function($q, $http, TenantListService, PrinterVendorModel) {

      this.getPrinterVendorsListPaged = function(PrinterVendorListPaging) {
        var deferred = $q.defer();
        var url = TenantListService.currentTenant.info._links['px:tenantVendors'].href  + "?" + PrinterVendorListPaging.getPagedUrlParameters() + '&embed=vendor';
        $http.get(url).then(function(response) {
          var printerVendorListObject = {
            page: response.data.page,
            _links: response.data._links,
            list: []
          };
          angular.forEach(response.data._embedded['px:tenantVendorResources'], function(vendor) {
            printerVendorListObject.list.add(new PrinterVendorModel(vendor));
          })
          deferred.resolve(printerVendorListObject);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

  }])
  

})();